/* ----------------- Hooks Imports --------------- */
import { pageViewTypes } from "@constants/tracking";
import ProgressView from "@features/dashboard/components/Progress/ChallengeProgressView";
import useAnalytics from "@hooks/useAnalytics";
import CustomTabs from "@memorang/ui/components/CustomTabs";
import LeaderboardContainer from "../screens/LeaderboardContainer";
const ChallengeProgressContainer = () => {
	const tabs = [
		{
			label: "Progress",
			content: <ProgressView />,
		},
		{
			label: "Leaderboard",
			content: <LeaderboardContainer />,
		},
	];

	useAnalytics({
		type: pageViewTypes.insights,
	});

	return <CustomTabs tabs={tabs} />;
};

export default ChallengeProgressContainer;
